import type { CompanyAnalytics, CompanyAnalyticsRequest } from "@/modules/companies/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export const COMPANY_ARTICLE_ANALYTICS_QUERY_KEY = "companies::company::analytics"
const COMPANY_ARTICLE_ANALYTICS_ENDPOINT = "/analytics/v1alpha1/company"

export const getCompanyAnalytics = async ({
  permalink,
  nextRequest,
}: CompanyAnalyticsRequest): Promise<CompanyAnalytics> => {
  const path = `${COMPANY_ARTICLE_ANALYTICS_ENDPOINT}/${permalink}`

  return fetcher(path, {
    nextRequest,
    serviceDomain: "KRAKEND_API",
  })
    .then(getResultFromResponse<CompanyAnalytics>({ transformResult: toCamelCaseKeys<CompanyAnalytics> }))
    .catch(handleFetchError(COMPANY_ARTICLE_ANALYTICS_ENDPOINT))
}
